/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute path='/promocode/:orderId'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import PromocodePage from '@routes/Promocode';

export const Route = createFileRoute('/promocode/$orderId')({
  staticData: { layout: { withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute
      component={PromocodePage}
      path='/promocode/:orderId'
    />
  )
});
